import React, { useEffect, useMemo, useState } from "react";
import { Aviation, Expeditor, File, MapsData, Order, User } from "../../../services";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import moment from "moment/moment";
import Loading from "../../../components/shared/Loading/Loading";
import CustomButton from "../../../components/custom/custom-button/CustomButton";
import { requestErrorDisplay } from "../../../utils";
import OrdersCreateAviationView from "../../../components/orders/views/OrdersCreateAviationView";
import { t } from "i18next";
import AviaOrdersParsingData from "../utils/AviaOrderParsingData";
import { useLanguage } from "../../../context/LanguageContext";
import { getCitiesRefreshTargets } from "../utils/cityRefresh";

import { buildAviationOrderPayload } from "../utils/aviationOrderPayload";
import useAviationAssignment from "../utils/useAviationAssignment";

const OrdersAviationEditPage = () => {
  const params = useParams();
  const { currentLanguage } = useLanguage();
  const { user } = useSelector((state) => state);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [orderId, setOrderId] = useState(
    params?.id ? params?.id : searchParams.get("id") ? searchParams.get("id") : null,
  );
  const [recipientUpdate, setRecipientUpdate] = useState(0);
  const [isLoadingGet, setLoadingGet] = useState(true);

  const [countries, setCountries] = useState([]);
  const [partners, setPartners] = useState([]);
  const [partnersLoaded, setPartnersLoaded] = useState(false);
  const [orderData, setOrderData] = useState(null);
  const [aviaDetails, setAviaDetails] = useState(null);

  const [errors, setErrors] = useState({});

  const [countryFrom, setCountryFrom] = useState();
  const [countryTo, setCountryTo] = useState();
  const [citiesFrom, setCitiesFrom] = useState([]);
  const [citiesTo, setCitiesTo] = useState([]);
  const [cityFrom, setCityFrom] = useState();
  const [cityTo, setCityTo] = useState();
  const [airportFrom, setAirportFrom] = useState();
  const [airportTo, setAirportTo] = useState();
  const [airportsFrom, setAirportsFrom] = useState([]);
  const [airportsTo, setAirportsTo] = useState([]);
  const [pickUpDate, setPickUpDate] = useState();
  const [pickUpStartTime, setPickUpStartTime] = useState();
  const [pickUpEndTime, setPickUpEndTime] = useState();
  const [deliveryDate, setDeliveryDate] = useState();
  const [deliveryStartTime, setDeliveryStartTime] = useState();
  const [deliveryEndTime, setDeliveryEndTime] = useState();
  const [addressTo, setAddressTo] = useState();
  const [addressFrom, setAddressFrom] = useState();
  const [coordinatesFrom, setCoordinatesFrom] = useState("");
  const [coordinatesTo, setCoordinatesTo] = useState("");
  const [addressIdFrom, setAddressIdFrom] = useState("");
  const [addressIdTo, setAddressIdTo] = useState("");
  const [recipientName, setRecipientName] = useState("");
  const [recipientEmail, setRecipientEmail] = useState("");
  const [recipientPhone, setRecipientPhone] = useState();
  const [senderName, setSenderName] = useState("");
  const [senderPhone, setSenderPhone] = useState();
  const [categoryName, setCategoryName] = useState("");
  const [weight, setWeight] = useState("");
  const [volume, setVolume] = useState("");
  const [details, setDetails] = useState();
  const [price, setPrice] = useState(0);
  const [netPrice, setNetPrice] = useState();
  const [distance, setDistance] = useState();
  const [createLoading, setLoadingCreate] = useState(false);
  const [insurance, setInsurance] = useState(false);
  const [declaredPrice, setDeclaredPrice] = useState(0);
  const [insurancePrice, setInsurancePrice] = useState();
  const [minPickDate, setMinPickDate] = useState(new Date(new Date().setHours(0)));
  const [minDeliveryDate, setMinDeliveryDate] = useState();
  const [partner, setPartner] = useState("");
  const assignment = useAviationAssignment(orderData);
  const [tenderDateEnd, setTenderDateEnd] = useState("");
  const [tenderEndTime, setTenderEndTime] = useState("");
  const [partnersForTender, setPartnersForTender] = useState([]);
  const [points, setPoints] = useState([]);
  const [routeDistance, setRouteDistance] = useState();
  const [routeDuration, setRouteDuration] = useState("");
  const [currency, setCurrency] = useState("EUR");
  const [acceptedCurrency, setAcceptedCurrency] = useState(null);

  const [citiesRefreshCountryId, setCitiesRefreshCountryId] = useState(null);
  const [isActualCities, setIsActualCities] = useState(true);
  const [isCalculatePrice, setIsCalculatePrice] = useState(true);

  const [files, setFiles] = useState([]);
  const [fileInvoice, setInvoiceFile] = useState(null);
  const [serverFiles, setServerFiles] = useState([]);

  const [isLoadingMap, setIsLoadingMap] = useState(false);
  const [routeData, setRouteData] = useState(null);
  const [routeStartCity, setRouteStartCity] = useState(null);

  useEffect(() => {
    if (!orderData?.expeditorId) return;
    setPartner(partners.find((item) => item.expeditorCompanyId === orderData.expeditorId) || {
      id: orderData.expeditorId,
      expeditorCompanyId: orderData.expeditorId,
      name: orderData.expeditorName || orderData.expeditorId,
    });
  }, [orderData, partners]);

  const updatePrice = (newPrice) => {
    setPrice(newPrice);
  };

  useEffect(() => {
    setIsActualCities(!(cityFrom?.isActual === false || cityTo?.isActual === false));
  }, [cityFrom, cityTo]);

  useEffect(() => {
    if (cityFrom?.id && cityTo?.id) {
      Order.getCalculateOrderPrice(cityFrom.id, cityTo.id)
        .then((response) => {
          setIsCalculatePrice(response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [cityFrom, cityTo]);

  const getDefaultData = async () => {
    setLoadingGet(true);
    try {
      if (user && user.id) {
        await Order.getCountries(currentLanguage)
          .then((response) => {
            console.log("countries", response.data);
            setCountries(response.data);
          })
          .catch((error) => {
            console.log(error);
            toast.error(error);
          });
      } else {
        console.log("Пользователь не определен");
        setCountries([]);
      }
    } catch (e) {
      toast.error("Ошибка при загрузке данных");
    } finally {
      setLoadingGet(false);
    }
  };

  useEffect(() => {
    getDefaultData();
  }, [user, currentLanguage]);

  useEffect(() => {
    Expeditor.getPartners()
      .then((response) => {
        if (response.status === 200) {
          const filteredPartners = response.data
            .filter((partner) => partner.state === "Confirmed" && partner.companyName)
            .map((partner) => ({
              ...partner,
              name: partner.companyName,
            }));

          setPartners(filteredPartners);
        } else {
          console.log("Список пуст");
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setPartnersLoaded(true);
      });
  }, []);

  useEffect(() => {
    if (!orderId || !partnersLoaded) return;

    AviaOrdersParsingData(orderId, currentLanguage, {
      setLoadingGet,
      setOrderData,
      setAviaDetails,
      setPartnersForTender,
      partners,
    });
  }, [orderId, partnersLoaded]);

  useEffect(() => {
    if (orderId) {
      File.getFilesByOrder(orderId, 6)
        .then((response) => {
          setServerFiles(response.data || []);
        })
        .catch((error) => {
          console.log("[getFilesByOrder error]", error);
        });
    }
  }, [orderId]);

  useEffect(() => {
    if (!countryFrom?.id) return;

    Order.getCities(currentLanguage, countryFrom.id)
      .then((res) => res.data)
      .then((data) => {
        const cities = data?.filter(city => city.name).sort((a, b) => a.name.localeCompare(b.name));
        setCitiesFrom(cities);

        if (orderData?.cityIdFrom) {
          const city = cities.find(c => c.id === orderData.cityIdFrom); 
          if (city) setCityFrom(city);
        }
      })
      .catch((error) => {
        requestErrorDisplay(error);
      });
  }, [countryFrom, orderData]);

  useEffect(() => {
    if (!citiesRefreshCountryId) return;

    Order.getCities(currentLanguage, citiesRefreshCountryId)
      .then((res) => res.data)
      .then((data) => {
        const cities = data?.filter((city) => city.name).sort((a, b) => a.name.localeCompare(b.name));
        const targets = getCitiesRefreshTargets(citiesRefreshCountryId, countryFrom, countryTo);
        if (targets.from) setCitiesFrom(cities);
        if (targets.to) setCitiesTo(cities);
      })
      .catch((error) => requestErrorDisplay(error))
      .finally(() => setCitiesRefreshCountryId(null));
  }, [citiesRefreshCountryId]);

  useEffect(() => {
    if (!countryTo?.id) return;

    Order.getCities(currentLanguage, countryTo.id)
      .then((res) => res.data)
      .then((data) => {
        const cities = data?.filter(city => city.name).sort((a, b) => a.name.localeCompare(b.name));
        setCitiesTo(cities);

        if (orderData?.cityIdTo) {
          const city = cities.find(c => c.id === orderData.cityIdTo);
          if (city) setCityTo(city);
        }
      })
      .catch((error) => {
        requestErrorDisplay(error);
      });
  }, [countryTo, orderData]);

  useEffect(() => {
    setIsLoadingMap(true);

    const isAddressRoute = addressIdFrom && addressIdTo && coordinatesFrom && coordinatesTo;
    const routeMethod = isAddressRoute ? "getRouteByAddressId" : "getRoute";
    const routeParams = isAddressRoute
      ? [addressIdFrom, addressIdTo]
      : [cityFrom?.id, cityTo?.id];

    if ((isAddressRoute && addressIdFrom && addressIdTo) || (!isAddressRoute && cityFrom?.id && cityTo?.id)) {
      MapsData[routeMethod](...routeParams)
        .then((response) => {
          try {
            if (response) setRouteDistance(response.data.distance);
            let parsedData = JSON.parse(response.data.jsonData);

            if (
              (isAddressRoute && response.data.fromCityId !== addressIdFrom) ||
              (!isAddressRoute && response.data.fromCityId !== cityFrom?.id)
            ) {
              parsedData = parsedData.reverse();
            }

            if (response) {
              setRouteStartCity(response.data.fromCityId);
              setRouteData(parsedData);
            } else {
              setRouteData(null);
              console.log(`[${routeMethod}]`, null);
            }
            setIsLoadingMap(false);
          } catch (error) {
            console.error("Ошибка при парсинге JSON:", error);
            setRouteData(null);
            setIsLoadingMap(false);
          }
        })
        .catch((error) => {
          console.error(error);
          setIsLoadingMap(true);
          toast.error("Произошла ошибка, попробуйте позже");
        });
    } else {
      setIsLoadingMap(false);
    }
  }, [cityFrom, cityTo, addressIdFrom, addressIdTo, coordinatesFrom, coordinatesTo]);

  useEffect(() => {
    if (!orderData || !countries.length) return;

    const fromCountry = countries.find(c => c.id === orderData.countryIdFrom);
    if (fromCountry) setCountryFrom(fromCountry);

    const toCountry = countries.find(c => c.id === orderData.countryIdTo);
    if (toCountry) setCountryTo(toCountry);

    setAddressFrom(orderData.addressFrom || "");
    setAddressTo(orderData.addressTo || "");
    setAddressIdFrom(orderData?.addressId || "");

    setSenderPhone(orderData.senderPhoneNumber || "");
    setSenderName(orderData.senderName || "");

    setRecipientName(orderData.recipientName || "");
    setRecipientPhone(orderData.recipientPhoneNumber || "");
    setRecipientEmail(orderData.recipientEmail || "");

    setWeight(orderData.weight ?? "");
    setVolume(orderData.volume ?? "");
    setCategoryName(orderData.categoryName || "");
    setDetails(orderData.details || "");

    if (orderData?.shippingDate) {
      setPickUpDate(new Date(orderData.shippingDate));
    }
    if (orderData?.shippingHourFrom != null) {
      const startTime = new Date();
      startTime.setHours(orderData.shippingHourFrom, 0, 0, 0);
      setPickUpStartTime(startTime);
    }
    if (orderData?.shippingHourTo != null) {
      const endTime = new Date();
      endTime.setHours(orderData.shippingHourTo, 0, 0, 0);
      setPickUpEndTime(endTime);
    }

    if (orderData.unloadingDate) {
      setDeliveryDate(new Date(orderData.unloadingDate));
    }
    if (orderData?.unloadingHourFrom != null) {
      const startTime = new Date();
      startTime.setHours(orderData.unloadingHourFrom, 0, 0, 0);
      setDeliveryStartTime(startTime);
    }
    if (orderData?.unloadingHourTo != null) {
      const endTime = new Date();
      endTime.setHours(orderData.unloadingHourTo, 0, 0, 0);
      setDeliveryEndTime(endTime);
    }

    if (orderData.distance !== null && orderData.distance !== undefined) {
      setDistance(orderData.distance);
    }

    if (orderData.tenderDateEnd) {
      setTenderDateEnd(new Date(orderData.tenderDateEnd));
      setTenderEndTime(new Date(orderData.tenderDateEnd));
    }

    if (orderData.currency) {
      setCurrency(orderData.currency);
    }
    if (orderData.acceptedCurrency) {
      setAcceptedCurrency(orderData.acceptedCurrency);
    }

    setPrice(orderData.price ?? 0);
  }, [orderData, countries]);

  const onDeleteServerFile = (fileId) => {
    setServerFiles((prev) => prev.filter((f) => f.fileId !== fileId));
  };

  const formData = () =>
    buildAviationOrderPayload(
      {
        orderId: orderId,
        type: orderData?.type ?? 0,
        isPublic: orderData?.isPublic ?? true,
        userId: user.id,
        price,
        netPrice: 0,
        currency: acceptedCurrency,
        distance: distance || 0,
        countryIdFrom: countryFrom?.id,
        cityIdFrom: cityFrom?.id,
        shippingDate: pickUpDate ? moment(pickUpDate).format("YYYY-MM-DD") : null,
        shippingHourFrom: pickUpStartTime ? Number(moment(pickUpStartTime).format("HH")) : null,
        shippingHourTo: pickUpEndTime ? Number(moment(pickUpEndTime).format("HH")) : null,
        countryIdTo: countryTo?.id,
        cityIdTo: cityTo?.id,
        unloadingDate: deliveryDate ? moment(deliveryDate).format("YYYY-MM-DD") : null,
        unloadingHourFrom: deliveryStartTime ? Number(moment(deliveryStartTime).format("HH")) : null,
        unloadingHourTo: deliveryEndTime ? Number(moment(deliveryEndTime).format("HH")) : null,
        addressFrom: addressFrom,
        addressTo: addressTo,
        addressId: addressIdFrom,
        copyCount: orderData?.copyCount ?? 0,
        number: orderData?.number ?? 0,
        internalNumber: orderData?.internalNumber ?? 0,
        expeditorId: orderData?.expeditorId || "",
        details: details || t("ordersCreateDesktop.detailsSection.noDescription"),
        weight: weight ? String(weight).replace(",", ".") : null,
        volume: volume ? String(volume).replace(",", ".") : null,
        categoryName: categoryName,
        unitMeasurement: orderData?.unitMeasurement || "",
        recipientName: recipientName,
        recipientPhoneNumber: recipientPhone,
        recipientEmail: recipientEmail,
        acceptedCurrency: acceptedCurrency,
        expectedUnloadingDate: orderData?.expectedUnloadingDate || null,
      },
      {
        ...assignment,
        partner,
        partnersForTender,
        tenderDateEnd,
        tenderEndTime,
        price,
        currency,
        acceptedCurrency,
      },
    );

  const createOrder = () => {
    const data = formData();

    setLoadingCreate(true);

    Aviation.update(orderId, data)
      .then((res) => res.data)
      .then((response) => {
        if (files.length) {
          const uploadPromises = files.map(f => uploadFile(orderId, f, 6));

          Promise.all(uploadPromises)
            .finally(() => {
              setLoadingCreate(false);
            });
        } else {
          setLoadingCreate(false);
        }

        toast.success(t('ordersCopy.toast.orderEdited'));
        navigate(`/aviation/list`);
      })
      .catch((error) => {
        console.log(error);
        setLoadingCreate(false);
        requestErrorDisplay(error, "Произошла ошибка, попробуйте позже");
      })
  };

  const uploadFile = (orderId, file, type = 6) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("type", type);
    formData.append("orderId", orderId);
    formData.append("FileName", file.name);
    formData.append("name", file.name);
    formData.append("Name", file.name);

    return File.addOrderDoc(formData)
      .then(() => {
        toast.info(t('ordersCreate.toast.fileUploaded'));
      })
      .catch((error) => {
        console.log(error);
        requestErrorDisplay(error, 'ordersCreate.errors.uploadFileError');
        return Promise.reject(error);
      });
  };

  const queryInsurance = () => {
    if (insurance) {
      setInsurance(false);
      setDeclaredPrice(0);
      setInsurancePrice(null);
      setInvoiceFile({});
    } else {
      setInsurance(true);
    }
  };

  const calcInsurance = (val) => {
    setDeclaredPrice(val);
    if (+val) setInsurancePrice(Math.trunc((+val / 100) * 0.3));
    else setInsurancePrice(null);
  };

  if (isLoadingGet) {
    return <Loading inBlock />;
  }

  if (!orderData) {
    return (
      <div role="alert">
        <p>{t("unifiedOrder.loadError")}</p>
        <CustomButton text={t("authSession.retry")} onClick={() => AviaOrdersParsingData(orderId, currentLanguage, {
          setLoadingGet, setOrderData, setAviaDetails, setPartnersForTender, partners,
        })} />
      </div>
    );
  }

  if (
    orderData &&
    user?.companyId !== orderData.companyId &&
    orderData?.status !== "awaitingoffer"
  ) {
    return (
      <div className="alert alert-warning text-center" role="alert">
        <strong>{t('common.warning')}</strong> {t('ordersCopy.errors.editNotAllowed')}
      </div>
    );
  }

  const getPropsData = () => ({
    recipientPhone,
    setCountryFrom,
    setCityFrom,
    countries,
    countryFrom,
    citiesFrom,
    cityFrom,
    countryTo,
    setCountryTo,
    setCityTo,
    citiesTo,
    cityTo,
    airportFrom,
    airportTo,
    setAirportFrom,
    setAirportTo,
    airportsFrom,
    airportsTo,
    pickUpDate,
    pickUpStartTime,
    pickUpEndTime,
    minPickDate,
    setPickUpDate,
    setPickUpStartTime,
    setPickUpEndTime,
    deliveryDate,
    deliveryStartTime,
    deliveryEndTime,
    minDeliveryDate,
    setDeliveryDate,
    setDeliveryStartTime,
    setDeliveryEndTime,
    addressTo,
    setAddressTo,
    setRecipientPhone,
    setRecipientName,
    recipientName,
    recipientUpdate,
    setRecipientEmail,
    addressFrom,
    setAddressFrom,
    setRecipientUpdate,
    volume,
    setVolume,
    weight,
    setWeight,
    categoryName,
    setCategoryName,
    details,
    setDetails,
    insurance,
    queryInsurance,
    declaredPrice,
    calcInsurance,
    fileInvoice,
    setInvoiceFile,
    files,
    setFiles,
    serverFiles,
    onDeleteServerFile,
    distance,
    price,
    netPrice,
    insurancePrice,
    createLoading,
    createOrder,
    updatePrice,
    setIsСallСities: setCitiesRefreshCountryId,
    isCalculatePrice,
    isLoadingMap,
    routeData,
    routeStartCity,
    partners,
    setPartner,
    partner,
    ...assignment,
    tenderDateEnd,
    tenderEndTime,
    setTenderDateEnd,
    setTenderEndTime,
    partnersForTender,
    setPartnersForTender,
    setCoordinatesFrom,
    setCoordinatesTo,
    coordinatesFrom,
    coordinatesTo,
    addressIdFrom,
    addressIdTo,
    setAddressIdFrom,
    setAddressIdTo,
    points,
    setPoints,
    senderName,
    setSenderName,
    setSenderPhone,
    setRouteDistance,
    setRouteDuration,
    acceptedCurrency,
    setAcceptedCurrency,
    currency,
    setCurrency,
  });

  return (
    <>
      <OrdersCreateAviationView
        {...getPropsData()}
        onPriceChange={setPrice}
        errors={errors}
        setErrors={setErrors}
        headTitle={t('ordersCopy.title.edit')}
        isEdit
        isReadOnly
      />
    </>
  );
};

export default OrdersAviationEditPage;
